import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sparkles, Menu, X, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useState } from 'react';

const Navigation = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isActive = (path) => location.pathname === path;
  const { count } = useCart();

  const navItems = [
    { path: '/', label: 'Accueil' },
    { path: '/boutique', label: 'Boutique' },
    { path: '/personnalisation', label: 'Diagnostic' },
    { path: '/univers', label: '✨ L\'Univers' },
    { path: '/fidelite', label: 'Fidélité' },
    { path: '/conseils', label: 'Conseils' },
    { path: '/contact', label: 'Contact' },
    { path: '/qui-sommes-nous', label: 'À propos' },
  ];

  return (
    <nav className="glass-header fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3 flex-shrink-0"
            data-testid="logo-link"
            onClick={() => setMobileOpen(false)}
          >
            <img
              src="/assets/logo-harmony.jpg"
              alt="Harmony Parfumerie"
              className="h-14 w-14 rounded-full object-cover"
            />
            <div className="hidden sm:flex flex-col">
              <span
                className="text-xl font-light tracking-tight text-[#5C2018] leading-none whitespace-nowrap"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
              >
                Harmony
              </span>
              <span className="text-[9px] uppercase tracking-[0.25em] text-[#1E7A6A] leading-none mt-1 whitespace-nowrap">
                Bar à parfums · Concept store
              </span>
            </div>
          </Link>

          {/* Desktop menu */}
          <div className="hidden lg:flex items-center gap-5 flex-wrap justify-end">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-[11px] uppercase tracking-[0.18em] transition-colors whitespace-nowrap ${
                  isActive(item.path)
                    ? 'text-[#5C2018] font-medium'
                    : 'text-[#332724] hover:text-[#1E7A6A]'
                }`}
                data-testid={`nav-${item.label.toLowerCase().replace(/ /g, '-').replace('à', 'a')}`}
              >
                {item.label}
              </Link>
            ))}
            <Link to="/panier" className="relative ml-2 p-2 rounded-full hover:bg-[#5C2018]/8 transition-colors" data-testid="nav-cart" aria-label="Panier">
              <ShoppingBag size={20} className="text-[#5C2018]" />
              {count > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#B8922A] text-[#FDFAF4] text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-medium">{count}</span>
              )}
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden text-[#332724]"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-[#B8922A]/20 pt-4">
            <div className="flex flex-col gap-3">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileOpen(false)}
                  className={`text-sm uppercase tracking-[0.2em] py-2 ${
                    isActive(item.path)
                      ? 'text-[#5C2018] font-medium'
                      : 'text-[#332724] hover:text-[#1E7A6A]'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
